import { LoadingPriorisationFormModel } from 'src/Libs/wallboxes/models'
import { LoadingPriorisationDto } from 'src/Libs/wallboxes/dto'

const loadPrioModelToFormTransformer = (model: LoadingPriorisationFormModel): LoadingPriorisationDto => {
  let tillSoc: number | undefined = undefined
  if (model.inSunMode) {
    tillSoc = Number(model.tillSoc)
  }

  return {
    isBattery: model.isBattery,
    inMixMode: model.inMixMode,
    inSunMode: model.inSunMode,
    tillSoc,
  }
}

export default loadPrioModelToFormTransformer
